export default __webpack_public_path__ + "static/media/nfl-header-background.3f712c89.png";